import { useHMSNotificationsListener } from "../hms";
import { useLivekitNotificationsListener } from "../livekit";
import type { ProviderNotificationsListenerOptions } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderNotificationsListener = (
  options: ProviderNotificationsListenerOptions,
) =>
  useProviderHook({
    hms: useHMSNotificationsListener,
    livekit: useLivekitNotificationsListener,
  })(options);
